<template lang="html">

  <section class="countries">   
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">

          <div class="col-lg-12 card-body row">
            <div class="col-lg-3">
              <h4 class="card-title">Countries</h4>
              <p class="card-description">
                {{curModel}} - {{getCurModel7DigitsCode}} - {{getLanguageLabel}}
              </p>
            </div>
            <div class="col-lg-4">             
              <div class="col-lg-12 row">
                <b-pagination
                  align="fill"
                  limit="6"
                  v-model="currentPage"
                  :total-rows="totalRowsResult"
                  :per-page="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  ellipsisText="..."
                  aria-controls=""
                  class="col-lg-10"
                ></b-pagination>
                <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-3">
                  <b-form-select-option value="5">5</b-form-select-option>
                  <b-form-select-option value="10">10</b-form-select-option>
                  <b-form-select-option value="20">20</b-form-select-option>
                  <b-form-select-option value="50">50</b-form-select-option>
                  <b-form-select-option value="100">100</b-form-select-option>
                </b-form-select>
              </div>
            </div>
            <div class="col-lg-5">
              <span class="float-right">    
                <b-button variant="primary mr-1" @click="refreshTable"><i class="mdi mdi-refresh"></i>Refresh Table</b-button>
                <b-button variant="primary mr-1" v-b-modal.modal-new-int-lab @click="btnNew" v-if="false"><i class="mdi mdi-plus"></i>New</b-button>           
                <b-button variant="primary mr-1" v-if="false"><i class="mdi mdi-file-export"></i>Export</b-button>
                <b-button variant="primary" v-if="false"><i class="mdi mdi-file-import"></i>Import</b-button>
              </span>
            </div>
            <b-table ref="countries_tab"
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="fields"
              :per-page="perPage"
              :current-page="1"
              primary-key="id"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            > 
              <!-- InfoButtons -->
              <template v-slot:cell(infoButtons)="data" lang="html">
                <b-row style="margin-left: 0; float: left; padding: 2px;">
                   <b-button  class="col-lg-3 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Country Model List"  @click="countryModelList(data.item.id)">
                      <i class="mdi mdi-information-outline"></i>
                  </b-button>
                </b-row>
                <b-row style="margin-left: 15px; float: left; padding: 2px;"> 
                  <b-button v-if="data.item.id!=codeCountryDefault && curModel!='DEFAULT'" class="col-lg-3 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Check Grid"  @click="curItem=data.item; checkGrid(data.item.id)">
                    <i class="mdi mdi-grid"></i>
                  </b-button> 
                  <b-button v-else class="col-lg-3 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Check Grid" disabled>
                    <i class="mdi mdi-grid"></i>
                  </b-button>                   
                </b-row>
              </template>

              <template v-slot:cell(editButton)="data" lang="html" v-if="false">                
                <b-row style="margin-left: 15px; float: left; padding: 2px;">
                  <b-button class="col-lg-3 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Edit Country" v-b-modal.modal-edit @click="curItem=data.item">
                    <i class="mdi mdi-pencil"></i>
                  </b-button>                  
                </b-row>
              </template>

              <!-- GridButtons-->
              <template v-slot:cell(gridButtons)="data" lang="html">
                <b-row style="margin-left: 0; float: left; padding: 2px;">
                   <b-button v-if="data.item.id!=codeCountryDefault && curModel!='DEFAULT'" class="col-lg-3 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Config Grid Json"  @click="curItem=data.item; gridJSON(data.item.id)">
                      <i class="mdi mdi-json"></i>
                  </b-button>
                   <b-button v-else class="col-lg-3 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Config Grid Json" disabled>
                      <i class="mdi mdi-json"></i>
                  </b-button>
                </b-row>
                <b-row style="margin-left: 15px; float: left; padding: 2px;">
                  <b-button v-if="data.item.id!=codeCountryDefault && curModel!='DEFAULT'" class="col-lg-3 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Car Grid Txt" @click="curItem=data.item; carGridTxt(data.item.id)">
                    <i class="  mdi mdi-car-sports"></i>
                  </b-button> 
                   <b-button v-else class="col-lg-3 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Car Grid Txt" disabled>
                    <i class="  mdi mdi-car-sports"></i>
                  </b-button> 
                </b-row>
              </template>

              <template v-slot:cell(enabled)="data" lang="html">
                <b-row>
                <h4   class="panel-title" style="margin:auto;">                 
                    <i  v-if="!data.item.enabled" class="mdi mdi-close-outline btn-outline-secondary" style="display: block;"></i>
                    <i v-else  class="mdi mdi-check-outline btn-outline-success" style="display: block;"></i>
                </h4>
              </b-row>

              </template>


              <template v-slot:cell(model_management)="data" lang="html">
                <b-row>
                  <b-button class="col-lg-3 p-1 m-auto" style="min-width: 2.875rem;" size="sm" variant="primary" title="Apri gestione modelli" @click='goToCountryModels(data.item.id,data.item.id + " - " + data.item.isoCode2 + " - " + getCountryDescriptionByLang(data.item,curLanguage))'>
                    <i class="mdi mdi-link-variant"></i>
                  </b-button>
                </b-row>
              </template>


              <template v-slot:cell(country_translation)="data" lang="html">
                <b-row style="margin-left: 0; float: left; padding: 2px;">
                  <input disabled type="text" :value="getCountryDescriptionByLang(data.item,curLanguage)" class="col-lg-10" />
                </b-row>              
              </template>
            </b-table>
            <b-tooltip target="tooltip-target-1" triggers="hover">                    
            </b-tooltip>
            <b-modal id="opt-color-details" title="Details Edit" v-if="curItem" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <b-table ref="countries_tab"
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              primary-key="code"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            > <!-- A custom formatted column -->
              <template v-slot:cell(accordionButton)="data" lang="html">
                <b-row>
                 <h4 class="panel-title" style="margin:auto;">
                  <a role="button" data-toggle="collapse" href="javascript:void(0);" @click="expandItem(data.item)" aria-expanded="true" aria-controls="collapseOne">
                    <i class="mdi mdi-arrow-right-drop-circle-outline"></i>
                  </a>
                </h4>
                </b-row>
              </template>
              <!-- A custom formatted column -->
              <template v-slot:cell(buttons)="data" lang="html">
                <b-row>
                  <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-modal.modal-edit @click="curItem=data.item">
                    <i class="mdi mdi-pencil"></i>
                  </b-button>
                  <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="danger" @click="deleteItem(data.item)">
                    <i class="mdi mdi-delete"></i>
                  </b-button>
                </b-row>
              </template>
            </b-table>
                </b-row>
             </b-container>
            </b-modal>
            <b-modal id="modal-edit" title="Modal Edit" v-if="curItem" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
               <b-container fluid>               
                <b-row>
                  <ul class="nav nav-tabs" id="editCountryTab" role="tablist">
                    <li class="nav-item">
                      <a class="nav-link" :class="{ 'active show': isActive('textFields') }" id="textFieldstab" @click.prevent="setActive('textFields')" data-toggle="tab" href="#textFields" role="tab" aria-controls="textFields" aria-selected="true">Translations</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" :class="{ 'active show': isActive('checkboxFields') }" id="checkboxFieldstab" @click.prevent="setActive('checkboxFields')"  data-toggle="tab" href="#checkboxFields" role="tab" aria-controls="checkboxFields" aria-selected="false">Configuration</a>
                    </li>                    
                  </ul>
                  <!-- booleans -->
                  <div class="col-lg-12">
                  <div class="tab-pane fade col-lg-12" role="tabpanel" aria-labelledby="checkboxFieldstab" :class="{ 'active show': isActive('checkboxFields') }" id="checkboxFields">
                    
                    <div class="col-lg-12">
                       <div class="row col-lg-12">
                            <div class="col-lg-2">Country Id:</div>
                            <input type="text" class="col-lg-3" placeholder="Country Id" v-model="curItem.id" disabled/>
                             <div class="col-lg-1"></div>
                            <div class="col-lg-2">Currency:</div>
                            <input type="text" class="col-lg-3" placeholder="Currency" v-model="curItem.currency" />
                        </div>
                        <hr>
                        <div class="row col-lg-12">
                            <div class="col-lg-2">Codmercato:</div>
                            <input type="text" class="col-lg-3" placeholder="Code" v-model="curItem.codmercato" />
                             <div class="col-lg-1"></div>
                            <div class="col-lg-2">Geo Region:</div>
                            <input type="text" class="col-lg-3" placeholder="geo region"  v-model="curItem.geoRegion" />
                        </div>
                        <hr>
                        <div class="row col-lg-12">
                          <div class="col-lg-2">Format Date:</div>
                            <input type="text" class="col-lg-3" placeholder="Code" v-model="curItem.formatDate" />
                            <div class="col-lg-1"></div>
                            <div class="col-lg-2">Iso code 2:</div>
                            <input type="text" class="col-lg-3" placeholder="Code" v-model="curItem.isoCode2" />
                        </div>
                        <hr>
                        <div class="row col-lg-12">
                          <div class="col-lg-2">Format Date month:</div>
                            <input type="text" class="col-lg-3" placeholder="Code" v-model="curItem.formatDateMonth" />
                            <div class="col-lg-1"></div>
                             <div class="col-lg-2">Iso code 3:</div>
                             <input type="text" class="col-lg-3" placeholder="Label" v-model="curItem.isoCode3"/>
                        </div>
                      </div>
                      <hr>
                      <div class="row col-lg-6">
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheck2" v-model="curItem.enabled">
                            <label class="custom-control-label" for="customCheck2">Enabled</label>
                          </div><hr>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheck3">
                            <label class="custom-control-label" for="customCheck3" v-model="curItem.hidden">Hidden</label>
                          </div><hr>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheck4"  v-model="curItem.enableAccesories">
                            <label class="custom-control-label" for="customCheck4">Enable Accessories</label>
                          </div><hr>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheck5" v-model="curItem.enableCustomProgram">
                            <label class="custom-control-label" for="customCheck5">Enable Custom Program</label>
                          </div>
                      </div>
                    </div>
                    <div class="tab-pane fade col-lg-10" role="tabpanel" aria-labelledby="textFieldstab" :class="{ 'active show': isActive('textFields') }" id="textFields">
                   
                     <div class="row col-lg-12">                       
                        <div class="col-lg-2">Desc En:</div><input type="text" class="col-lg-3" placeholder="Label" v-model="curItem.descEn"/>
                      </div>
                      <hr>
                      <div class="row col-lg-12">
                        <div class="col-lg-2">Desc De:</div>
                        <input type="text" class="col-lg-3" placeholder="Code" v-model="curItem.descDe" />
                        <div class="col-lg-2"></div>
                        <div class="col-lg-2">Desc Fr:</div><input type="text" class="col-lg-3" placeholder="Label" v-model="curItem.descFr"/>
                      </div>
                      <hr>
                      <div class="row col-lg-12">
                        <div class="col-lg-2">Desc It:</div>
                        <input type="text" class="col-lg-3" placeholder="Code" v-model="curItem.descIt" />
                        <div class="col-lg-2"></div>
                        <div class="col-lg-2">Desc Es:</div><input type="text" class="col-lg-3" placeholder="Label" v-model="curItem.descEs"/>
                      </div>
                      <hr>                      
                    </div>
                  </div>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="saveCurItem(curItem)">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
             <b-modal id="modal-new-int-lab" title="New Country"  size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>               
                <b-row>
                  <ul class="nav nav-tabs" id="newCountryTab" role="tablist">
                    <li class="nav-item">
                      <a class="nav-link" :class="{ 'active show': isActive('textFields') }" id="textFieldstab" @click.prevent="setActive('textFields')" data-toggle="tab" href="#textFields" role="tab" aria-controls="textFields" aria-selected="true">Text Fields</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" :class="{ 'active show': isActive('checkboxFields') }" id="checkboxFieldstab" @click.prevent="setActive('checkboxFields')"  data-toggle="tab" href="#checkboxFields" role="tab" aria-controls="checkboxFields" aria-selected="false">checkboxFields</a>
                    </li>
                  </ul>
                  <!-- booleans -->
                  <div class="col-lg-12">
                  <div class="tab-pane fade col-lg-12" role="tabpanel" aria-labelledby="checkboxFieldstab" :class="{ 'active show': isActive('checkboxFields') }" id="checkboxFields">
                    
                    <div class="col-lg-12">
                        <div class="row col-lg-12">
                            <div class="col-lg-2">Codmercato:</div>
                            <input type="text" class="col-lg-3" placeholder="Code" v-model="newItem.codmercato" />
                             <div class="col-lg-1"></div>
                            <div class="col-lg-2">Geo Region:</div>
                            <input type="number" class="col-lg-3" placeholder="Number" v-model="newItem.geoRegion" />
                        </div>
                        <hr>
                        <div class="row col-lg-12">
                          <div class="col-lg-2">Format Date:</div>
                            <input type="text" class="col-lg-3" placeholder="Code" v-model="newItem.formatDate" />
                            <div class="col-lg-1"></div>
                            <div class="col-lg-2">Iso code 2:</div>
                            <input type="text" class="col-lg-3" placeholder="Code" v-model="newItem.isoCode2" />
                        </div>
                        <hr>
                        <div class="row col-lg-12">
                          <div class="col-lg-2">Format Date month:</div>
                            <input type="text" class="col-lg-3" placeholder="Code" v-model="newItem.formatDateMonth" />
                            <div class="col-lg-1"></div>
                             <div class="col-lg-2">Iso code 3:</div>
                             <input type="text" class="col-lg-3" placeholder="Label" v-model="newItem.isoCode3"/>
                        </div>
                      </div>
                      <hr>
                      <div class="row col-lg-6">
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheck2" v-model="newItem.enabled">
                            <label class="custom-control-label" for="customCheck2">Enabled</label>
                          </div><hr>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheck3">
                            <label class="custom-control-label" for="customCheck3" v-model="newItem.hidden">Hidden</label>
                          </div><hr>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheck4"  v-model="newItem.enableAccesories">
                            <label class="custom-control-label" for="customCheck4">Enable Accessories</label>
                          </div><hr>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheck5" v-model="newItem.enableCustomProgram">
                            <label class="custom-control-label" for="customCheck5">Enable Custom Program</label>
                          </div>
                      </div>
                    </div>
                    <div class="tab-pane fade col-lg-10" role="tabpanel" aria-labelledby="textFieldstab" :class="{ 'active show': isActive('textFields') }" id="textFields">
                   
                     <div class="row col-lg-12">                       
                        <div class="col-lg-2">Desc En:</div><input type="text" class="col-lg-3" placeholder="Label" v-model="newItem.descEn"/>
                      </div>
                      <hr>
                      <div class="row col-lg-12">
                        <div class="col-lg-2">Desc De:</div>
                        <input type="text" class="col-lg-3" placeholder="Code" v-model="newItem.descDe" />
                        <div class="col-lg-2"></div>
                        <div class="col-lg-2">Desc Fr:</div><input type="text" class="col-lg-3" placeholder="Label" v-model="newItem.descFr"/>
                      </div>
                      <hr>
                      <div class="row col-lg-12">
                        <div class="col-lg-2">Desc It:</div>
                        <input type="text" class="col-lg-3" placeholder="Code" v-model="newItem.descIt" />
                        <div class="col-lg-2"></div>
                        <div class="col-lg-2">Desc Es:</div><input type="text" class="col-lg-3" placeholder="Label" v-model="newItem.descEs"/>
                      </div>
                      <hr>                      
                    </div>
                  </div>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="createItem(curItem)">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
            
          </div>
        </div>
      </div>
    </div>
  </section>

</template>
<style>
.expandableContent {
  transition: 300ms ease-out;
}
.closed {
  height: 0vh !important;
}
.table td,
.table th {
  max-width: 25vw;
}

li.nav-item.active > a {
  color: #fff !important;
  text-shadow: 2px 2px 4px rgba(100, 100, 100, 0.5);
}
</style>
<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
 const FileDownload = require('js-file-download');
export default {
  name: 'countries',
  methods: {
    checkGrid(idCountry){ 
      this.setSpinnerStatus(true);    
      this.axios
      .get('/ccb/auth/api/checkGrid/'+idCountry+'/'+this.getCurModel,  {
        params:null,
        ...this.authHeader}          
          )
          .then((response) => {            
            window.datas = response.data;
             
            const messageNodes = this.$createElement(
                'pre',
                {
                  domProps: { innerHTML: response.data }
                }
              )


            this.$bvModal.msgBoxOk([messageNodes], {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              }).then(value=>{
               
                
              })
              setTimeout(() => {
                   document.querySelector('.modal-body pre').classList.add('external-text')                   
                   document.querySelector('.modal-dialog-centered').style.cssText = "max-width: 80vw;width: 80vw;"
                }, 10);                 
          }).finally(resp=>{
            this.setSpinnerStatus(false);
          });
    },
    gridJSON(idCountry){ 
      this.setSpinnerStatus(true);    
      this.axios
      .get('/ccb/auth/api/getConfigGrid/',  {
        params: {country:idCountry,model: this.getCurModel7DigitsCode, language: this.getCurLanguage},
        ...this.authHeader}          
          )
          .then((response) => {            
            window.datas = response.data;
             
            const messageNodes = this.$createElement(
                'code',
                {
                  domProps: { innerHTML: JSON.stringify(response.data) }
                }
              )


            this.$bvModal.msgBoxOk([messageNodes], {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              }).then(value=>{
               
                
              })
              setTimeout(() => {
                   document.querySelector('.modal-body code').classList.add('external-text')                   
                   document.querySelector('.modal-dialog-centered').style.cssText = "max-width: 80vw;width: 80vw;"
                }, 10);                  
          }).finally(resp=>{
            this.setSpinnerStatus(false);
          });
    },
     carGridTxt(idCountry){
        this.setSpinnerStatus(true);   
      this.axios
      .get('/ccb/auth/api/carGridTxt/'+idCountry+'/'+this.getCurModel7DigitsCode+'/'+this.getCurLanguage,  {
        params: null,
        ...this.authHeader}          
          )
          .then((response) => {            
            window.datas = response.data;
             
            const messageNodes = this.$createElement(
                'div',
                {
                  domProps: { innerHTML: response.data, class: "external-text" }
                }
              )


            this.$bvModal.msgBoxOk([messageNodes], {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              }).then(value=>{
               
                
              })
              setTimeout(() => {
                   document.querySelector('.modal-body div').classList.add('external-text')
                  document.querySelector('.modal-dialog-centered').classList.add('scaled')  
                }, 10);
         //(response.data.content)                   
          }).finally(resp=>{
            this.setSpinnerStatus(false);
          });
    },
    countryModelList(id){    
       this.setSpinnerStatus(true);
      this.axios
      .get('/ccb/auth/api/countryModel/getModelListByCountry',  {
        params: {country: id},
        ...this.authHeader}          
          )
          .then((response) => {
            console.log(response.data)
            window.datas = response.data;
             
            const messageNodes = this.$createElement(
                'pre',
                {
                  domProps: { innerHTML: response.data }
                }
              )


            this.$bvModal.msgBoxOk([messageNodes], {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              }).then(value=>{
               
                
              })
              setTimeout(() => {
                  document.querySelector('.modal-dialog-centered').classList.add('scaled')  
                }, 10);
         //(response.data.content)                   
          }).finally(resp=>{
            this.setSpinnerStatus(false);
          });;
    },
    expandItem(element){
      console.log(element)
      this.accordionManager()
    },
    goToCountryModels(idKey,title){
          this.$router.push({name: "country_models", params: { idKey : idKey, from: 'countries',title: title }}); 
    },        
  accordionManager () {
    document.querySelectorAll('tr[role=row][data-pk]').forEach(el=>{     
      var tr = document.createElement('tr')
          tr.className = 'expandableContent closed';
      var td = document.createElement('td')
          td.setAttribute('colspan',6);
          td.style.backgroundColor = 'yellow';  

          tr.appendChild(td);
          el.parentNode.appendChild(tr);
          el.parentNode.insertBefore(el,tr)
    })
  },
    deleteItem(item) {
      this.$bvModal.msgBoxConfirm('Vuoi veramente cancellare '+item.code+'?', {
        title: 'Elimina',
        //size: 'sm',
        //buttonSize: 'sm',
        //headerBgVariant: 'danger',
        okVariant: 'danger',
        okTitle: 'Elimina',
        cancelTitle: 'Annulla',
        //footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
            this.axios
            .delete('/ccb/auth/fe/optGridLabel/' + item.id ,this.authHeader)
            .then(response => {
              this.curItem=null
            }
            )           

        })
        .catch(err => {
          // An error occurred
        })
    },
    saveCurItem(curItem) {
      //TODO salvare curItem
       window.curr = curItem

      var intLabObj = curItem

      this.axios
        .put('/ccb/auth/fe/country/' + curItem.id, intLabObj ,this.authHeader)
        .then(response => {
           if(response.status == 200) {            
              this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
              }
            this.refreshTable();
             this.$bvModal.hide('modal-edit')

          }
          
        )
     
    },
    createItem() {
     var intLabObj = this.newItem     
      intLabObj.language = {id: this.getCurLanguageObj.id}
      this.axios
      .post('/ccb/auth/fe/country', intLabObj, this.authHeader)
        .then(response => {
          if(response.status == 200) {
          this.$bvModal.msgBoxOk(response.message, {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true
          })
          }
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        })
    },
    search() {
      this.setLastSearch(this.search) 
      this.setSpinnerStatus(true);
      var params = {
            optGroup: this.getCurLabelGroup, modelName: this.getCurModel, language: this.getCurLanguage, 
            page: this.currentPage - 1, size: this.perPage, sortBy: this.sortBy, sortDesc: this.sortDesc, 
            label: this.labelFilter, code: this.codeFilter }
      
      this.axios
      .get('/ccb/auth/fe/country/allEnabledPaged' ,  {
        params: params,
        ...this.authHeader}          
          )
          .then((response) => {
          this.setCountryList(response.data.content)    
           this.totalRowsResult=response.data.totalElements;      
           this.setSpinnerStatus(false);           
          });
    },
    btnNew() {
      
    },
    refreshTable() {
      this.search();
    },
    getCountryDescriptionByLang(item,curLanguage){
        var label = 'descEn'
        Object.keys(item).forEach((key)=>{
          var bapp = curLanguage.toUpperCase()
          var bln = curLanguage.length

          var aLan = key.substr(bln*-1).toUpperCase()
       
          if(aLan == bapp)
              label = key 
        }) 
        return item[label]
    },
    isActive (menuItem) {
      return this.activeNewCountryTab === menuItem
    },
    setActive (menuItem) {
      this.activeNewCountryTab = menuItem
    },
    ...mapActions([
      'setCurApp',
      'setLastSearch',
      'setSpinnerStatus',
      'setInterfaceLabels',
      'setCurLabelGroup',
      'setCountryList'
      
    ])
  },
  props: ['action','activeGroup'],
  data () {
    return { 
      codeCountryDefault: 0,
      activeNewCountryTab: 'textFields',
      totalRowsResult: 0,
      routerParams: null,
      currentPage:1,
      perPage:10,
      sortBy:'id',      
      sortDesc: false,
      curItem: null,
      newItem : {id:null, codmercato: null, currency: null, pricemask: null, geoRegion: null,formatDate: null, formatDateMonth: null,  enabled : false, hidden: false, enableAccesories: false, enableCustomProgram: false, enableWltpEmissions: false, enableNedcComsumptions: false, descEn : null ,descDe: null , descFr: null, descIt: null, descEs: null,isoCode2: null, isoCode : null},
      fields: [
        {
          key: ' ',
          label: ' ',
          sortable: false
        },
        {
          key: 'enabled',
          label: 'Enabled',
          sortable: false
        },
        {
          key: 'id',
          label: 'Code',
          sortable: false
        },
        {
          key: 'isoCode2',
          label: 'iso-code',
          sortable: false
        },
        {
          key: 'country_translation',
          label: 'Description',
          sortable: false
        },
        {
          key: 'tabele',
          label: 'Adm',
          sortable: false
        },
        {
          key: 'model_management',
          label: 'Model Management',
          sortable: false,
          visible : true
        },                
        {                  
          key: 'infoButtons',
          label: 'Info',
          sortable: false
        },
        {
          key: 'gridButtons',
          label: 'Grid',
          sortable: false
        },
        {
          key: 'editButton',
          label: '',
          sortable: false
        }

      ],
      labelFilter: '',
      codeFilter: ''
    }
  },
  computed: {
    items () {
      return (this.getCountryList && this.getCountryList.length) ? this.getCountryList : [];
    },
    ...mapState([
      'curLanguage',
      'curModel',      
      'languages',
      'models'
    ]),
    ...mapGetters([
      'getCurModel7DigitsCode',
      'getLanguageLabel',
      'getInterfaceLabels',
      'getLabelGroupList',
      'getCurUser',
      'authHeader',
      'getCurLabelGroup',
      'getCurLanguage',
      'getCurLanguageObj',
      'getCurModel',
      'getCountryList'
    ])
  },
   watch: {
     $route (to,from){
       this.routerParams = to;
       if(to.query.activeGroup && to.query.activeGroup !=null){
          this.setCurLabelGroup(to.query.activeGroup);        
        }
       if(to.query.action && to.query.action === 'search'){
        // alert('search')
        this.search();        
       }
     },
    items (oldValue, newValue) {

    },
     currentPage(newValue,oldValue){
      this.refreshTable();
    },
    perPage(newValue,oldValue){
      this.refreshTable();
    },
    sortBy(newValue,oldValue){
      this.refreshTable();
    },
    sortDesc(newValue,oldValue){
      this.refreshTable();
    }
  },
  mounted() {
    window.scoper = this
    if(this.$route.query.activeGroup && this.$route.query.activeGroup !=null){
          this.setCurLabelGroup(this.$route.query.activeGroup);        
        }
        
      this.search();        

    this.setCurApp('ccadm');
  }
}
</script>
<style>
.modal-dialog-centered.scaled {
  max-width: 90vw !important;
  margin: 15vh auto !important;
  text-align: center;
  max-height: 50vh !important;
  min-height: 70vh !important;
  transform: scale(0.9) !important;
}
</style>
<style scoped lang="scss">
@import "../../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
.btn i {
  margin: auto !important;
}
</style>
